import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          popupUpgrade: {
            TITLE: 'Get more with Advanced Plans',
            DESC: `This feature is not available for
          your account type. Upgrade to Advanced plans to get a fulfilled experience.`,
            NOT_NOW: 'Not now',
            VIEW_PLANS_AND_PRICING: 'View plans and pricing',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          popupUpgrade: {
            TITLE: 'Nâng cấp tài khoản',
            DESC: `Tính năng này không có sẵn với tài
            khoản của bạn. Vui lòng nâng cấp tài khoản để trải nghiệm đầy đủ các tính năng của FiinGate`,
            NOT_NOW: 'Để lúc khác',
            VIEW_PLANS_AND_PRICING: 'Xem các gói và chính sách giá',
          },
        },
      },
    },
  }),
)
